import type { AnimationOption } from './KeyframeAnimation'

export type ButtleOption = Partial<{
  uri: string
  visible: boolean
  radius: number
  color: string
}>

export enum ELevel {
  Low = 0,
  Medium = 1,
  High = 2,
}

export type Option = {
  visible?: boolean
  uri: string
  level: ELevel
  animation?: AnimationOption
  bubble?: ButtleOption
}